import React, { useEffect, useState } from 'react';

import {
  CmBox,
  CmButton,
  CmFlex,
  CmFormControl,
  CmFormLabel,
  CmHeading,
  CmSwitch,
} from '@/components/uiParts';
import { CmTag } from '@/components/uiParts/Tag/CmTag';
import { InitialDeliveryStore } from '@/pages/store-management/master-stores/components/Sidebar/MasterStoreSidebarForm/service';
import {
  ConnectDeliveryService,
  DeliveryServiceDisplayName,
  integrationStatusColor,
  integrationStatusMap,
} from '@/pages/store-management/master-stores/service';
import { useStoreManagementDeliveryStoreUpdateLinkedStatus } from '@/services/StoreManagement/DeliveryStores/hooks/updateLinkedStatus/useStoreManagementDeliveryStoreUpdateLinkedStatus';
import { LinkedStatus } from '@/services/StoreManagement/MasterStores/hooks/show/useStoreManagementMasterStoreShow';

type Props = {
  deliveryStore: InitialDeliveryStore;
  deliveryServiceName: ConnectDeliveryService;
  deliveryServiceDisplayName: DeliveryServiceDisplayName;
  handleOpenModalAndSetDeliveryStore: (
    deliveryService: ConnectDeliveryService
  ) => void;
};

export const TitleLine: React.FC<Props> = ({
  deliveryStore,
  deliveryServiceName,
  deliveryServiceDisplayName,
  handleOpenModalAndSetDeliveryStore,
}) => {
  const [linkedStatus, setLinkedStatus] = useState<LinkedStatus>(
    deliveryStore.linked_status || 'disabled'
  );

  useEffect(() => {
    setLinkedStatus(deliveryStore.linked_status || 'disabled');
  }, [deliveryStore.linked_status]);

  const linkedStatusMap = {
    disabled: {
      text: '非表示',
      color: 'red',
      onChange: async () => {
        await useStoreManagementDeliveryStoreUpdateLinkedStatus(
          deliveryStore.id,
          {
            linked_status: 'enabled',
          }
        );
        setLinkedStatus('enabled');
        alert('タブレットで表示にするように更新しました。');
      },
    },
    enabled: {
      text: '表示',
      color: '#319795',
      onChange: async () => {
        await useStoreManagementDeliveryStoreUpdateLinkedStatus(
          deliveryStore.id,
          {
            linked_status: 'disabled',
          }
        );
        alert('タブレットで非表示にするように更新しました。');
        setLinkedStatus('disabled');
      },
    },
  }[linkedStatus];

  return (
    <CmHeading
      size="md"
      display="flex"
      alignItems="center"
      width="full"
      justifyContent="space-between"
    >
      <CmFlex alignItems="center">
        <CmBox mr={4}>{deliveryServiceDisplayName}</CmBox>
        <CmTag
          mr={4}
          colorScheme={integrationStatusColor[deliveryStore.integration_status]}
        >
          {integrationStatusMap[deliveryStore.integration_status]}
        </CmTag>
        {integrationStatusMap[deliveryStore.integration_status] ===
          '連携済' && (
          <CmFormControl display="flex" alignItems="center" width="auto">
            <CmFormLabel
              color={linkedStatusMap.color}
              htmlFor="linkedStatus"
              fontWeight={'bold'}
              mr={2}
              mb={0}
              whiteSpace="nowrap"
            >
              {linkedStatusMap.text}
            </CmFormLabel>
            <CmSwitch
              id="linkedStatus"
              isChecked={linkedStatus === 'enabled'}
              onChange={linkedStatusMap.onChange}
            />
          </CmFormControl>
        )}
      </CmFlex>
      {integrationStatusMap[deliveryStore.integration_status] !== '連携済' &&
        integrationStatusMap[deliveryStore.integration_status] !== '解約済' && (
          // @ts-ignore TS2590
          <CmButton
            size="sm"
            isDisabled={deliveryStore.id === ''}
            onClick={() =>
              handleOpenModalAndSetDeliveryStore(deliveryServiceName)
            }
          >
            申請
          </CmButton>
        )}
    </CmHeading>
  );
};
